import { create } from "zustand";

/**
 * Whether the SpecTree Toolbox Help panel is open (epic PI-SPEC-SW-E302,
 * feature PI-SPEC-SW-1557, ER-1655 Resolved Decision 7).
 *
 * The rail's Help item, F1 and Ctrl+/ open and close it; the panel's close
 * button closes it. Not persisted: a reload starts with the panel closed, and
 * the conversation itself lives only in memory (`use-help-bridge`).
 */
interface HelpPanelState {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
  close: () => void;
}

export const useHelpPanelStore = create<HelpPanelState>()((set) => ({
  open: false,
  setOpen: (open) => {
    set({ open });
  },
  toggle: () => {
    set((state) => ({ open: !state.open }));
  },
  close: () => {
    set({ open: false });
  },
}));

/**
 * True for the keys that open and close Help from anywhere in the Toolbox:
 * F1, and Ctrl+/ (Cmd+/ is not one; ER-1655 names Ctrl+/). Pure; exported
 * for tests.
 */
export function isHelpShortcut(
  event: Pick<KeyboardEvent, "key" | "ctrlKey" | "metaKey" | "altKey" | "shiftKey">
): boolean {
  if (event.key === "F1" && !event.ctrlKey && !event.metaKey && !event.altKey) return true;
  return event.key === "/" && event.ctrlKey && !event.metaKey && !event.altKey;
}
